export const HOME = "/";
export const PREFERENCES = "/preferences";
export const DASHBOARD = "/dashboard";
